import { get } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAutoAwesome, MdOutlineMail } from "react-icons/md";
import { useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import { GET_EMAIL_TEMPLATES } from "utils/api/graphql/queries/emailTemplate";
import { useEmailComposer } from "./context";
import { isRemoteEmailTemplateIcon } from "utils/emailTemplateIcon";
import { replaceVariables } from "utils/emailVariables";

const TemplateSelector = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTACT);
  const EMAIL = t("EMAIL_COMPOSER", { returnObjects: true });

  const { contact, advisor, organization, applyTemplate } = useEmailComposer();

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { data: templatesData } = useQuery(GET_EMAIL_TEMPLATES, {
    variables: { where: { active: true } },
  });

  const templates = get(templatesData, "emailTemplates.data", []);

  const handleSelectTemplate = (template) => {
    const context = { contact, advisor, organization };
    const resolvedSubject = replaceVariables(template.subject || "", context);
    const resolvedBody = replaceVariables(template.body || "", context);
    applyTemplate({ subject: resolvedSubject, body: resolvedBody });
    setDropdownOpen(false);
  };

  if (!templates.length) return null;

  return (
    <div className="email-composer__templates">
      <button
        className="email-composer__templates-btn"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <MdAutoAwesome />
        <span>{EMAIL?.TEMPLATES || "Modèles"}</span>
      </button>
      {dropdownOpen && (
        <div className="email-composer__templates-dropdown">
          <div className="email-composer__templates-header">
            {EMAIL?.AVAILABLE_TEMPLATES || "MODÈLES DISPONIBLES"}
          </div>
          {templates.map((template) => (
            <div
              key={template.id}
              className="email-composer__templates-item"
              onClick={() => handleSelectTemplate(template)}
            >
              <div className="email-composer__templates-icon">
                {isRemoteEmailTemplateIcon(template.icon) ? (
                  <img
                    src={template.icon}
                    alt=""
                    className="email-composer__templates-icon-img"
                  />
                ) : template.icon ? (
                  template.icon
                ) : (
                  <MdOutlineMail size={22} />
                )}
              </div>
              <div className="email-composer__templates-info">
                <span className="email-composer__templates-label">
                  {template.label}
                </span>
                {template.description && (
                  <span className="email-composer__templates-desc">
                    {template.description}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TemplateSelector;
